import * as React from 'react';
import { LoadingContainer } from '../../components/Layout';
import { useQuery } from '@apollo/client';
import { adminMinimalStoreQuery } from '../../graphql/queries';
import { Badge } from 'reactstrap';
import { Spacer } from '../../pages/PartnerSearchNew/styled';
import StoreStatusBadge, {
  AcquiredByBadge,
  ServicePackageBadge,
  OnboardingStatusBadge,
} from './StoreStatusBadge';
import { getColorForTier } from '@/utils/color';
import { useDocumentTitle } from '@/hooks/useDocumentTitle';

interface MerchantStorePageProps {
  storeId: string;
  brandId: string;
}

export function getStoreBadges(store: any) {
  return (
    <div className="d-inline-block">
      {(store.revenue_tier || store.tier) && (
        <Badge
          style={{
            background: getColorForTier(store.revenue_tier || store.tier),
          }}
          pill
        >
          {store.revenue_tier || store.tier}
        </Badge>
      )}
      <Spacer width={10} />
      {store.published && (
        <Badge color="success" pill>
          published
        </Badge>
      )}
      <Spacer width={10} />
      {(store.available_soon || store.coming_soon) && (
        <Badge pill>Coming Soon</Badge>
      )}
      <Spacer width={10} />
      <StoreStatusBadge
        contracted_date={store.contracted_date}
        onboarded_date={store.onboarded_date}
        contract_end_date={store.contract_end_date}
      />
      <Spacer width={10} />
      <AcquiredByBadge
        acquired_at={store.acquired_at}
        acquired_by={store.acquired_by}
      />
      <Spacer width={10} />
      <OnboardingStatusBadge onboarding_status={store.onboarding_status} />
      <Spacer width={10} />
      <ServicePackageBadge service_package={store.service_package_type} />
      <Spacer width={10} />
      {store.inkassokennzeichen && (
        <Badge color="warning" pill>
          Inkasso
        </Badge>
      )}
    </div>
  );
}

export function MerchantStorePage(props: MerchantStorePageProps) {
  const { storeId, brandId } = props;

  const { data = { store: null, brand: null } } = useQuery(
    adminMinimalStoreQuery,
    {
      variables: { store_id: storeId, brand_id: brandId },
    },
  );
  const { store, brand }: { store: any; brand: any } = data;

  const storeName = store?.name;
  useDocumentTitle('PageTitles:store', storeName);

  if (!store || !brand) {
    return <LoadingContainer className="p-3" />;
  }

  return (
    <div className="mt-5" data-use-bs>
      <h3 className="d-inline-block me-3">{storeName}</h3>
      {getStoreBadges(store)}
    </div>
  );
}
